import is from '@sindresorhus/is';

import type { JobProfileVersion } from '~/shared/data-contract/job-profile-versions';
import type { TranslationKey } from '~/shared/internationalization/translation';

export const getVersionsFromCurrent = (
    versions: readonly JobProfileVersion[] | undefined,
    currentVersion: number | undefined,
): readonly JobProfileVersion[] => {
    const currentVersionIndex = versions?.findIndex((version) => version.version === currentVersion);
    const relevantVersions = versions?.slice(currentVersionIndex, versions.length);

    return relevantVersions ?? [];
};

export const getNewerVersions = (
    versions: readonly JobProfileVersion[] | undefined,
    currentVersion: number | undefined,
): readonly JobProfileVersion[] => {
    const currentVersionIndex = versions?.findIndex((version) => version.version === currentVersion);
    const relevantVersions = versions?.slice(0, currentVersionIndex);

    return relevantVersions ?? [];
};

export const hasReviewedOrPublishedVersion = (versions: readonly JobProfileVersion[]): boolean => {
    return versions.some((version) => !is.null(version.reviewedAt) || !is.null(version.publishedAt)) ?? false;
};

export const getPublishedVersionInfo = (
    versions: readonly JobProfileVersion[] | undefined,
): {
    readonly hasPreviousPublishedVersion: boolean;
    readonly lastPublishedVersion: JobProfileVersion | null | undefined;
} => {
    const publishedVersions = versions?.filter((version) => is.null(version.publishedAt) === false) ?? [];
    const lastPublishedVersion = publishedVersions.length > 0 ? publishedVersions[publishedVersions.length - 1] : null;

    return {
        hasPreviousPublishedVersion: publishedVersions.length > 0,
        lastPublishedVersion,
    };
};

export const getPublisherNotificationKey = (hasPreviousPublishedVersion: boolean): TranslationKey => {
    return hasPreviousPublishedVersion
        ? 'pages.job-architecture-v2.job-role-publish-new-version-notification'
        : 'pages.job-architecture-v2.job-role-publish-notification';
};
